import { Component, HostListener, OnInit } from '@angular/core';
import "./main.js";
@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.css']
})
export class TopnavComponent implements OnInit {
  isSticky: boolean = false;

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isSticky = window.pageYOffset >= 100;
    if(this.isSticky){
      var elements= document.getElementById('header');
      elements.className += " header-scrolled";
  }else{
    var elements= document.getElementById('header');
    elements.className = " fixed-top";
  }
  }
  constructor() {

  }
  mob_click(){
    var elements= document.getElementById('navbar');
    elements.className = " navbar-mobile";
    let btn = document.getElementById("mob");
    if(btn.className === "bi mobile-nav-toggle bi-x"){
    btn.className = "bi mobile-nav-toggle bi-list";
    elements.className = " navbar";
    }else{
    btn.className = "bi mobile-nav-toggle bi-x";

    }
  }

  ngOnInit(): void {
  }



}
